import {TemplateRef} from '@angular/core';

export class ReferencedEntity {
    entityName?: string;
    columnToKeyMap?: { [index: string]: string };
    filterValue?: string;
}

export class GridColumn {
    prop: string;
    private _label: string | (() => string);
    name: string;
    width: number;
    sortable: boolean;
    hidden: boolean;
    type: string;
    precision: number;
    createSummary: boolean;
    referencedReport: any;
    referencedReportInput: any;
    referencedEntity: ReferencedEntity;
    dateTimeFormat: string;
    cellTemplate: TemplateRef<any>;
    isThumbnail: boolean;
    idProp: string;
    constructor(options: {
        field?: string,
        label?: string | (() => string),
        columnWidth?: number,
        sortable?: boolean,
        hidden?: boolean
        order?: number,
        type?: string,
        precision?: number,
        createSummary?: boolean,
        referencedReport?: any,
        referencedReportInput?: any,
        referencedEntity?: ReferencedEntity,
        dateTimeFormat?: string,
        cellTemplate?: any,
        isThumbnail?: boolean,
        idProp?: string,
    } = {}) {
        this.prop = options.field;
        this._label = options.label || '';
        this.name = typeof this._label === 'function' ? this._label() : this._label;
        this.width = options.columnWidth;
        this.sortable = options.sortable !== false;
        this.hidden = !!options.hidden;
        this.type = options.type || '';
        this.precision = options.precision || 0;
        this.createSummary = options.createSummary || false;
        this.referencedReport = options.referencedReport || null;
        this.referencedReportInput = options.referencedReportInput || {};
        this.referencedEntity = options.referencedEntity || null;
        this.dateTimeFormat = options.dateTimeFormat;
        this.cellTemplate = options.cellTemplate;
        this.isThumbnail = options.isThumbnail || false;
        this.idProp = options.idProp;
    }

    get label(): string {
        return typeof this._label === 'function' ? this._label() : this._label;
    }

    setLabel(label: string | (() => string)): void {
        this._label = label;
        this.name = this.label;
    }
}
